
document.addEventListener("scroll", function () {
    let scrollTop = window.scrollY;
    const rotationSpeed = 0.01 //0.2; // Adjust rotation speed
    const rotationOffset = -90 //0; // Adjust rotation offset
    let rotation = (scrollTop * rotationSpeed) + rotationOffset;

    const circularTexts = document.querySelectorAll(".circular-text");

    if (circularTexts.length === 0) {
        //console.log("No .circular-text elements found");
        return;
    }

    circularTexts.forEach((el) => {
        el.style.transform = `rotate(${rotation}deg)`;
    });

    //console.log(`rotate(${rotation}deg) applied to ${circularTexts.length} element(s)`);
});